module["exports"] = [
  "#{city_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/city.js
// module id = 1581
// module chunks = 1